// frontend/src/components/newui/NewQuickPlayButton.jsx
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import NewQuickPlayModal from './NewQuickPlayModal';

const PlayIconOutlineRounded = ({ className = "w-5 h-5" }) => (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
            d="M8.2 7 L8.2 17 L16.6 12 Z"
            stroke="currentColor"
            strokeWidth="2.8"
            strokeLinejoin="round"
            strokeLinecap="round"
            fill="none"
        />
    </svg>
);

const NewQuickPlayButton = ({
                                variant = 'primary', // 'primary', 'ctaBlue', 'ctaYellow'
                                size = 'medium', // 'small', 'medium', 'large'
                                className = '',
                                showIcon = true,
                                text = 'Juego Rápido'
                            }) => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => {
        if (isAuthenticated) {
            setShowModal(true);
        } else {
            navigate('/login');
        }
    };

    // Base styles
    const base =
        "inline-flex items-center justify-center gap-2.5 " +
        "rounded-[14px] md:rounded-[16px] " +
        "font-bold tracking-wider leading-none uppercase " +
        "transition-transform duration-150 hover:scale-[1.02] active:scale-[0.98]";

    // Variant styles
    const variants = {
        primary: "bg-[#2284DF] text-white hover:bg-[#2A91F4] border-2 border-[#1E75C6]",
        ctaBlue: "bg-[#2284DF] text-white hover:bg-[#2A91F4] border-2 border-[#1E75C6]",
        ctaYellow: "bg-[#fce503] text-[#122436] hover:bg-[#fce503]/90 border-2 border-[#fce503]",
        outline: "bg-[#0E2238]/80 border-2 border-[#fce503] text-[#fce503] hover:bg-[#fce503]/10",
    };

    // Size styles
    const sizes = {
        small: "h-10 px-4 text-xs md:text-sm",
        medium: "h-12 md:h-14 px-6 md:px-8 text-sm md:text-base",
        large: "h-14 md:h-16 px-8 md:px-10 text-base md:text-lg",
    };

    const iconSizes = {
        small: "w-4 h-4",
        medium: "w-5 h-5 md:w-5.5 md:h-5.5",
        large: "w-6 h-6 md:w-7 md:h-7",
    };

    return (
        <>
            <button
                onClick={handleClick}
                className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
            >
                {showIcon && (
                    <span className="inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/12 ring-1 ring-white/20 shrink-0">
                        <PlayIconOutlineRounded className={iconSizes[size]} />
                    </span>
                )}
                <span className="whitespace-nowrap">{text}</span>
            </button>

            {/* Modal */}
            {showModal && (
                <NewQuickPlayModal onClose={() => setShowModal(false)} />
            )}
        </>
    );
};

export default NewQuickPlayButton;